<div class="text-center py-2">
    <p class="text-muted"><a class="link text-muted" href="https://codesoft.dev" target="_blank">
        codesoft</a> &copy; {{ currentDate | date:'yyyy' }} {{ pageHome ? 'All rights reserved' : '' }}</p>
</div>
